"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var query_1 = require("../models/query");
var typeChecks_1 = require("../utils/typeChecks");
var object_1 = require("../utils/object");
var isArrayLike_1 = require("../utils/isArrayLike");
var isQueryOptionsObject_1 = require("../utils/isQueryOptionsObject");
var PropertyQuery_1 = require("./PropertyQuery");
var AllocationsQuery_1 = require("./AllocationsQuery");
var StatisticsQuery_1 = require("./StatisticsQuery");
var TimeseriesQuery_1 = require("./TimeseriesQuery");
var FundManagerQuery_1 = require("./FundManagerQuery");
var FundManagersQuery_1 = require("./FundManagersQuery");
var LoggedInUserQuery_1 = require("./LoggedInUserQuery");
var CommentaryQuery_1 = require("./CommentaryQuery");
var DisclaimerQuery_1 = require("./DisclaimerQuery");
var DocumentQuery_1 = require("./DocumentQuery");
var SingleDocumentQuery_1 = require("./SingleDocumentQuery");
var ResponseQuery_1 = require("./ResponseQuery");
var ValueQuery_1 = require("./ValueQuery");
var DynamicQuery_1 = require("./DynamicQuery");
var InputQuery_1 = require("./InputQuery");
var StatisticQuery_1 = require("./StatisticQuery");
var ObjectQuery_1 = require("./ObjectQuery");
var GlobalQuery_1 = require("./GlobalQuery");
var FundListsQuery_1 = require("./FundListsQuery");
var ClientConfigurationQuery_1 = require("./ClientConfigurationQuery");
var UrlQuery_1 = require("./UrlQuery");
var ContextStore_1 = require("../stores/ContextStore");
var WindowQuery_1 = require("./WindowQuery");
var JoinQuery_1 = require("./JoinQuery");
var ScenarioQuery_1 = require("./ScenarioQuery");
var PortfolioQuery_1 = require("./PortfolioQuery");
var PortfolioEntityQuery_1 = require("./PortfolioEntityQuery");
var AssetQuery_1 = require("./AssetQuery");
var ScenarioReportQuery_1 = require("./ScenarioReportQuery");
var ScenarioStatisticQuery_1 = require("./ScenarioStatisticQuery");
var EntitiesQuery_1 = require("./EntitiesQuery");
var BreakdownAnalysisQuery_1 = require("./BreakdownAnalysisQuery");
var ExternalApiQuery_1 = require("./externalApi/ExternalApiQuery");
var TransactionsQuery_1 = require("./TransactionsQuery");
var DocumentEntityQuery_1 = require("./DocumentEntityQuery");
var UserConfigurationQuery_1 = require("./UserConfigurationQuery");
var ArticleQuery_1 = require("./ArticleQuery");
var CoursesQuery_1 = require("./CoursesQuery");
var HistoricalDatasetsQuery_1 = require("./HistoricalDatasetsQuery");
var DatasetQuery_1 = require("./DatasetQuery");
var WordpressGlobalSearchContentQuery_1 = require("./WordpressGlobalSearchContentQuery");
exports.CONTEXT_STORE_WINDOW_KEY = '__ksysContextStore__';
var Query = /** @class */ (function () {
    function Query(options, translationHelper, callStackLevel) {
        var _this = this;
        this.options = options;
        this.translationHelper = translationHelper;
        this.callStackLevel = callStackLevel;
        this.debug = {
            error: function () {
                var messages = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    messages[_i] = arguments[_i];
                }
                _this.debugBase.apply(_this, __spreadArrays([query_1.DebugType.error], messages));
            },
            info: function () {
                var messages = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    messages[_i] = arguments[_i];
                }
                _this.debugBase.apply(_this, __spreadArrays([query_1.DebugType.info], messages));
            },
            warn: function () {
                var messages = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    messages[_i] = arguments[_i];
                }
                _this.debugBase.apply(_this, __spreadArrays([query_1.DebugType.warn], messages));
            },
        };
    }
    Object.defineProperty(Query, "contextStore", {
        get: function () {
            if (!window[exports.CONTEXT_STORE_WINDOW_KEY]) {
                window[exports.CONTEXT_STORE_WINDOW_KEY] = new ContextStore_1.ContextStore();
            }
            return window[exports.CONTEXT_STORE_WINDOW_KEY];
        },
        enumerable: true,
        configurable: true
    });
    Query.getContextAndConfiguration = function (executionOptions, queryOptions) {
        if (queryOptions) {
            var defaultContextParentKey = executionOptions.defaultContextParentKey;
            var _a = queryOptions.contextParentKey, contextParentKey = _a === void 0 ? defaultContextParentKey : _a, _b = queryOptions.contextKey, contextKey = _b === void 0 ? 'default' : _b;
            var contextStore = executionOptions.contextStore || Query.contextStore;
            if (contextStore) {
                var contextAndConfiguration = contextStore.get({ contextParentKey: contextParentKey, contextKey: contextKey });
                return contextAndConfiguration;
            }
        }
        return undefined;
    };
    Query.getContext = function (executionOptions, queryOptions) {
        if (executionOptions) {
            var context = executionOptions.context;
            if (context) {
                return context;
            }
        }
        if (queryOptions) {
            var contextAndConfiguration = this.getContextAndConfiguration(executionOptions, queryOptions);
            return contextAndConfiguration && contextAndConfiguration.context;
        }
        return undefined;
    };
    Query.getContextConfiguration = function (executionOptions, queryOptions) {
        if (executionOptions) {
            var contextConfiguration = executionOptions.contextConfiguration;
            if (contextConfiguration) {
                return contextConfiguration;
            }
        }
        if (queryOptions) {
            var contextAndConfiguration = this.getContextAndConfiguration(executionOptions, queryOptions);
            return contextAndConfiguration && contextAndConfiguration.contextConfiguration;
        }
        return undefined;
    };
    Query.convertQueryKeyValue = function (queryKeyValue, executionOptions, staticOptions) {
        var response = {};
        if (queryKeyValue) {
            Object.keys(queryKeyValue).forEach(function (key) {
                var valueQueryOptions = queryKeyValue[key];
                if (valueQueryOptions) {
                    var valueQuery = new Query(valueQueryOptions, staticOptions && staticOptions.translationHelper);
                    var value = valueQuery.execute(executionOptions);
                    response[key] = value;
                }
            });
        }
        return response;
    };
    Query.convertQueryMime = function (queryMime, executionOptions, staticOptions) {
        var response = {};
        if (typeof queryMime === 'object') {
            var _queryResponseMappings = queryMime._queryResponseMappings;
            var keys = Object.keys(queryMime);
            if (_queryResponseMappings) {
                for (var _i = 0, _a = _queryResponseMappings; _i < _a.length; _i++) {
                    var queryResponseMapping = _a[_i];
                    Query.loadQueryResponseMapping(queryResponseMapping, response, queryMime, executionOptions, keys, staticOptions);
                }
            }
            keys.forEach(function (key) {
                Query.loadQueryMimeKey(response, key, queryMime, executionOptions, staticOptions);
            });
            return response;
        }
        return queryMime;
    };
    Query.loadQueryResponseMapping = function (queryResponseMapping, response, queryMime, executionOptions, keys, staticOptions) {
        var key = queryResponseMapping.key, children = queryResponseMapping.children;
        Query.loadQueryMimeKey(response, key, queryMime, executionOptions, staticOptions);
        var keyIndex = keys.indexOf(key);
        if (keyIndex > -1) {
            keys.splice(keyIndex, 1);
        }
        var parentResponse = response[key];
        if (children && isArrayLike_1.isArrayLike(children) && children.length > 0) {
            for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
                var child = children_1[_i];
                Query.loadQueryResponseMapping(child, response, queryMime, __assign(__assign({}, executionOptions), { responseContext: parentResponse }), keys, staticOptions);
            }
        }
    };
    Query.loadQueryMimeKey = function (response, key, queryMime, executionOptions, staticOptions) {
        var value = queryMime[key];
        if (value) {
            if (isArrayLike_1.isArrayLike(value)) {
                response[key] = value.map(function (item) {
                    return Query.convertQueryMime(item, executionOptions, staticOptions);
                });
            }
            else if (typeof value === 'object') {
                if (value.queryOptionsType) {
                    var valueQuery = new Query(value, staticOptions && staticOptions.translationHelper);
                    var responseValue = valueQuery.execute(executionOptions);
                    response[key] = responseValue;
                }
                else {
                    response[key] = Query.convertQueryMime(value, executionOptions, staticOptions);
                }
            }
            else {
                response[key] = value;
            }
        }
    };
    Query.prototype.mergeExecutionOptions = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var response = {};
        for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
            var arg = args_1[_a];
            if (arg) {
                var fullContext = arg.context, executionOptions = __rest(arg, ["context"]);
                var _b = (fullContext || {}), entityByType = _b.entityByType, context = __rest(_b, ["entityByType"]);
                var hasContext = typeof context === 'object' && Object.keys(context).length > 0;
                response = object_1.deepMergeObjects(response, executionOptions, hasContext ? { context: context } : {});
                if (entityByType) {
                    if (!response.context) {
                        response.context = {};
                    }
                    response.context.entityByType = entityByType;
                }
            }
        }
        return response;
    };
    Query.prototype.debugBase = function (type) {
        var messages = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            messages[_i - 1] = arguments[_i];
        }
        if (this.options && this.options.debug && this.options.debug.key) {
            var prefix = "QueryOptions Debug - \"" + this.options.debug.key + "\": ";
            console[type].apply(console, __spreadArrays([prefix], messages));
        }
    };
    Query.prototype.execute = function (executionOptions) {
        this.debug.info('Execute Started', { options: this.options });
        // in the case that the QueryOptions passed has already been converted, we will just return it as is.
        if (!isQueryOptionsObject_1.default(this.options)) {
            this.debug.info('Already converted to a value, options are not of type IQueryOptions');
            return this.options;
        }
        var _a = this.options, queryOptionsType = _a.queryOptionsType, value = _a.value, _b = _a.separators, separators = _b === void 0 ? [] : _b, keyQuery = _a.keyQuery, codeQuery = _a.codeQuery;
        if (keyQuery) {
            this.debug.info('keyQuery defined', { keyQuery: keyQuery });
            var query_2 = new Query(keyQuery, this.translationHelper);
            this.options.key = query_2.execute(executionOptions);
            this.debug.info('key = ', this.options.key);
        }
        if (codeQuery) {
            this.debug.info('codeQuery defined', { codeQuery: codeQuery });
            var query_3 = new Query(codeQuery, this.translationHelper);
            this.options.code = query_3.execute(executionOptions);
            this.debug.info('code = ', this.options.code);
        }
        var query;
        if (!typeChecks_1.isUndefined(value)) {
            query = new ValueQuery_1.ValueQuery(this.options, this.translationHelper);
        }
        else if (queryOptionsType) {
            switch (queryOptionsType) {
                case 'response':
                    query = new ResponseQuery_1.ResponseQuery(this.options, this.translationHelper);
                    break;
                case 'dynamic':
                    query = new DynamicQuery_1.DynamicQuery(this.options, this.translationHelper);
                    break;
                case 'input':
                    query = new InputQuery_1.InputQuery(this.options, this.translationHelper);
                    break;
                case 'property':
                    query = new PropertyQuery_1.PropertyQuery(this.options, this.translationHelper);
                    break;
                case 'allocations':
                    query = new AllocationsQuery_1.AllocationsQuery(this.options, this.translationHelper);
                    break;
                case 'historicalDatasets':
                    query = new HistoricalDatasetsQuery_1.HistoricalDatasetsQuery(this.options, this.translationHelper);
                    break;
                case 'statistics':
                    query = new StatisticsQuery_1.StatisticsQuery(this.options, this.translationHelper);
                    break;
                case 'statistic':
                    query = new StatisticQuery_1.StatisticQuery(this.options, this.translationHelper);
                    break;
                case 'timeseries':
                    query = new TimeseriesQuery_1.TimeseriesQuery(this.options, this.translationHelper);
                    break;
                case 'fundManager':
                    query = new FundManagerQuery_1.FundManagerQuery(this.options, this.translationHelper);
                    break;
                case 'fundManagers':
                    query = new FundManagersQuery_1.FundManagersQuery(this.options, this.translationHelper);
                    break;
                case 'commentaries':
                    query = new CommentaryQuery_1.CommentaryQuery(this.options, this.translationHelper);
                    break;
                case 'disclaimers':
                    query = new DisclaimerQuery_1.DisclaimerQuery(this.options, this.translationHelper);
                    break;
                case 'documents':
                    query = new DocumentQuery_1.DocumentQuery(this.options, this.translationHelper);
                    break;
                case 'document':
                    query = new SingleDocumentQuery_1.SingleDocumentQuery(this.options, this.translationHelper);
                    break;
                case 'fundLists':
                    query = new FundListsQuery_1.FundListsQuery(this.options, this.translationHelper);
                    break;
                case 'object':
                    query = new ObjectQuery_1.ObjectQuery(this.options, this.translationHelper);
                    break;
                case 'global':
                    query = new GlobalQuery_1.GlobalQuery(this.options, this.translationHelper);
                    break;
                case 'clientConfiguration':
                    query = new ClientConfigurationQuery_1.ClientConfigurationQuery(this.options, this.translationHelper);
                    break;
                case 'userConfiguration':
                    query = new UserConfigurationQuery_1.UserConfigurationQuery(this.options, this.translationHelper);
                    break;
                case 'url':
                    query = new UrlQuery_1.UrlQuery(this.options, this.translationHelper);
                    break;
                case 'window':
                    query = new WindowQuery_1.WindowQuery(this.options, this.translationHelper);
                    break;
                case 'join':
                    query = new JoinQuery_1.JoinQuery(this.options, this.translationHelper);
                    break;
                case 'scenario':
                    query = new ScenarioQuery_1.ScenarioQuery(this.options, this.translationHelper);
                    break;
                case 'scenarioReport':
                    query = new ScenarioReportQuery_1.ScenarioReportQuery(this.options, this.translationHelper);
                    break;
                case 'portfolio':
                    query = new PortfolioQuery_1.PortfolioQuery(this.options, this.translationHelper);
                    break;
                case 'portfolioEntity':
                    query = new PortfolioEntityQuery_1.PortfolioEntityQuery(this.options, this.translationHelper);
                    break;
                case 'asset':
                    query = new AssetQuery_1.AssetQuery(this.options, this.translationHelper);
                    break;
                case 'scenarioStatistic':
                    query = new ScenarioStatisticQuery_1.ScenarioStatisticQuery(this.options, this.translationHelper);
                    break;
                case 'entities':
                    query = new EntitiesQuery_1.EntitiesQuery(this.options, this.translationHelper);
                    break;
                case 'breakdownAnalysis':
                    query = new BreakdownAnalysisQuery_1.BreakdownAnalysisQuery(this.options, this.translationHelper);
                    break;
                case 'loggedInUser':
                    query = new LoggedInUserQuery_1.LoggedInUserQuery(this.options, this.translationHelper);
                    break;
                case 'externalApi':
                    query = new ExternalApiQuery_1.ExternalApiQuery(this.options, this.translationHelper);
                    break;
                case 'transactions':
                    query = new TransactionsQuery_1.TransactionsQuery(this.options, this.translationHelper);
                    break;
                case 'none':
                    query = new ValueQuery_1.ValueQuery(this.options, this.translationHelper);
                    break;
                case 'documentEntity':
                    query = new DocumentEntityQuery_1.DocumentEntityQuery(this.options, this.translationHelper);
                    break;
                case 'article':
                    query = new ArticleQuery_1.ArticleQuery(this.options, this.translationHelper);
                    break;
                case 'courses':
                    query = new CoursesQuery_1.CoursesQuery(this.options, this.translationHelper);
                    break;
                case 'dataset':
                    query = new DatasetQuery_1.DatasetQuery(this.options, this.translationHelper);
                    break;
                case 'wordpressGlobalSearch':
                    query = new WordpressGlobalSearchContentQuery_1.WordpressGlobalSearchContentQuery(this.options, this.translationHelper);
                    break;
            }
        }
        if (query) {
            var queryResponse = query.execute(executionOptions, this.callStackLevel);
            if (queryResponse && typeof queryResponse === 'string' && separators && separators.length > 0) {
                queryResponse = this.stripWrappingSeparators(queryResponse, separators);
            }
            return queryResponse;
        }
    };
    Query.prototype.stripWrappingSeparators = function (queryResponse, separators) {
        for (var separatorIndex = 0; separatorIndex < separators.length; separatorIndex++) {
            var separator = separators[separatorIndex];
            var separtorLength = separator.length;
            while (queryResponse.startsWith(separator)) {
                queryResponse = queryResponse.substr(separtorLength);
            }
            while (queryResponse.endsWith(separator)) {
                queryResponse = queryResponse.substr(0, queryResponse.length - separtorLength);
            }
        }
        return queryResponse;
    };
    return Query;
}());
exports.Query = Query;
//# sourceMappingURL=Query.js.map